module.exports = __webpack_public_path__ + "img/horizontal_3_4_8017.f4ede2d4.png";